import {inject} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ComponentCanDeactivate} from './component-can-deactivate';

export const canDeactivateGuard = (component: ComponentCanDeactivate) => {
  const translate = inject(TranslateService);
  const message = translate.instant('global.cancel_screen');
  
  if (!component.canDeactivate()) {
    return confirm(message);
  }
  return true;
};
